import React, { useState, useEffect } from 'react';
import { Amplify } from 'aws-amplify';
// import { generateClient } from 'aws-amplify/api';
import { getCurrentUser } from 'aws-amplify/auth'; // Import from V6
import config from './amplifyconfiguration.json';
// import { listClaimCoverages } from './graphql/queries';
import './ClaimCoverage.css';
import './App.css'
import awsmobile from './aws-exports.js';

// Configure Amplify with the settings from amplifyconfiguration.json
Amplify.configure(config);

function ClaimCoverage({ user }) {
  const [claimCoverages, setClaimCoverages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState(''); // New state for success message


  // Fetch user email from Amplify Auth (V6)
  const getUserEmail = async () => {
    try {
      const user = await getCurrentUser();
      return user.signInDetails.loginId;  // Grabs the email from loginId (V6 change)
    } catch (err) {
      console.error('Error fetching user email:', err);
      return '';
    }
  };

  // Define the fetchData function outside of useEffect to reuse it
  const fetchData = async () => {
    setLoading(true); // Set loading to true at the start of fetch
    setError(''); // Clear any previous errors

    try {
        const cognitoIdToken = localStorage.getItem(`CognitoIdentityServiceProvider.${awsmobile.aws_user_pools_web_client_id}.${user.userId}.idToken`);
        
        const api_url = 'https://qab6yotn8g.execute-api.us-west-1.amazonaws.com/dev-lisa/ClaimCoverage';
        const filter_key = 'coverage_status';
        const filter_value = 'claim';
        const full_url = `${api_url}?${filter_key}=${filter_value}`;

        const response = await fetch(full_url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${cognitoIdToken}`
        }
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error(`API Request Failed: Status ${response.status}`, errorText);
        throw new Error(`Server responded with status: ${response.status} - ${errorText}`);
      }
      
      // *** NEW DATA HANDLING START ***
      const apiResponse = await response.json(); // Parse the outer JSON
      console.log('API GET Response:', apiResponse); // Log the full object
      const responseBody = (apiResponse);
      
      if (responseBody && Array.isArray(responseBody.Items)) {
        setClaimCoverages(responseBody.Items); // Set the 'Items' array to state
      } else {
        console.warn("API response body did not contain an 'Items' array or was empty:", responseBody);
        setClaimCoverages([]); // Ensure it's an empty array if no items
      }
      // *** NEW DATA HANDLING END ***


    } catch (error) {
        console.error('Error during API call:', error);
        setError(`Failed to load claims: ${error.message}`);
        setClaimCoverages([]); // Clear existing data on error

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(); // Call fetchData to initiate the API request
  }, []);

  // Function to handle claiming coverage
  const [claimingId, setClaimingId] = useState(null);

  const handleClaim = async (coverage) => {
    const email = await getUserEmail();
    if (coverage.requestor_email === email) {
      alert("You cannot claim your own coverage request.");
      return;
    }
  
    const cognitoIdToken = localStorage.getItem(`CognitoIdentityServiceProvider.${awsmobile.aws_user_pools_web_client_id}.${user.userId}.idToken`);
    const confirmClaim = window.confirm('Are you sure you want to claim this coverage request?');
    if (!confirmClaim) return;

    setClaimingId(coverage.id); // 🌀 Show spinner

  
    const payload = {
      "body": {
        "id": coverage.id,
        "se_email": email,
        "coverage_status": "claimed"
      }
    };
  
    try {
      const response = await fetch('https://qab6yotn8g.execute-api.us-west-1.amazonaws.com/dev-lisa/ClaimCoverage', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${cognitoIdToken}`
        },
        body: JSON.stringify(payload)
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error(`API PATCH Request Failed: Status ${response.status}`, errorText);
        throw new Error(`Server responded with status: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      console.log('API PATCH Response:', data);

      if (data.statusCode !== 200) {
        setSuccessMessage(`Request failed: ${data.body.message}`);
      }
      else {
        setSuccessMessage('Coverage claimed successfully!');
      }

      // Clear the success message after a few seconds
      setTimeout(() => {
        setSuccessMessage('');
      }, 8000); // Message visible for 8 seconds

      fetchData(); // Re-fetch data
  
      setTimeout(() => setSuccessMessage(''), 10000); // Clear success message after 10 seconds
  
    } catch (error) {
      console.error('Error claiming coverage:', error);
    } finally {
      setClaimingId(null); // ✅ Reset spinner
    }
/*
    //Google Apps Script - POST URL and payload
    const url2 = 'https://qab6yotn8g.execute-api.us-west-1.amazonaws.com/dev-lisa/CalendarEvent'; 
    const payload2 = {
      title: `${coverage.requestor_name} ${coverage.requestor_surname} - ${coverage.reason} - Coverage`,
      description: 'Please reach out to covering SEs',
      date: `${coverage.coverage_date}`,
      team_email: `sales-team@example.com`, // CHANGE TO TEAM EMAIL WHEN READY FOR PRODUCTION
      coverer_email: user.signInDetails.loginId
    };
    // Make POST request to Google Apps Script
    try {
      const response2 = await fetch(url2, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `${cognitoIdToken}`
        },
        body: JSON.stringify(payload2),
      });
      const data2 = await response2.text();
      console.log('Google Apps Script Response:', data2);

    } catch (error) {
      console.error('Error creating calendar event:', error);
    }
*/

  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;


return (
    <div>
      {/* Simply display the message if it exists */}
      {successMessage && (
        <p className="success-message">
          {successMessage}
        </p>
      )}

      <h1 className="title home-title">Claim Coverage</h1>
      
      {claimCoverages.length === 0 ? (
        <p>There are no dates to claim!</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>SE Name</th>
              <th>Team Name</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {claimCoverages.map((coverage) => (
              <tr key={coverage.id}>
                <td>{coverage.requestor_name} {coverage.requestor_surname}</td>
                <td>{coverage.team_name}</td>
                <td>{coverage.coverage_date}</td>
                <td>
                  <button
                    onClick={() => handleClaim(coverage)}
                    disabled={claimingId === coverage.id}
                    className={claimingId === coverage.id ? "claiming" : ""}
                  >
                    {claimingId === coverage.id ? (
                      <>
                        <span className="spinner"></span> Claiming...
                      </>
                    ) : (
                      "Claim"
                    )}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ClaimCoverage;